'use strict';

/* global yith_wcaf */

import { $ } from '../../../src/globals.js';
import { enhanceSelect, initFields } from './fields';

export default class YITH_WCAF_Admin_Panel {
	// container object.
	$container;

	constructor( $container ) {
		this.$container = $container;

		this.initFields();
		this.initBulkAction();
	}

	initFields() {
		initFields( this.$container );
	}

	initBulkAction() {
		const $bulkActionSelect = $(
			'#bulk-action-selector-top',
			this.$container
		);

		if ( ! $bulkActionSelect.length ) {
			return;
		}

		enhanceSelect( $bulkActionSelect, {
			minimumResultsForSearch: Infinity,
			minimumInputLength: 0,
		} );
	}
}
